
$(document).ready(function(e) { 
	
	(function($) {
          'use strict';
          // call our plugin
          var Nav = new hcOffcanvasNav('#main-nav #menu-main-menu', {
            disableAt: false,
            customToggle: '.toggle',
            levelSpacing: 50,
            //navTitle: 'All Categories',
            levelTitles: true,
            levelTitleAsBack: true,
            pushContent: '#container-box',
            labelClose: false
          });

    })(jQuery);

	////////////
	if($('#banner-slide').length){
		$('#banner-slide').owlCarousel({
			autoplay:true,
			dots: false,
			nav: true,
			navText: [ '' ],
			rewind:true,
			autoplayTimeout:5000,
			loop:true,
			items:1,
			margin:0,
			responsive:{
			  200:{ items:1 },
			  300:{ items:1 },
			  630:{ items:1 },
			  980:{ items:1 }
			}
		});
	}


	if($('#featured-slide').length){
		$('#featured-slide').owlCarousel({
			autoplay:true,
			dots: false,
			nav: true,
			navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
			rewind:true,
			autoplayTimeout:5000,
			loop:true,
			items:4,
			margin:30,
			responsive:{
			  200:{ items:1 },
			  300:{ items:1 },
			  480:{ items:2 },
			  630:{ items:3 },
			  980:{ items:3 },
			  1260:{ items:4 }
			}
		});
	}



	if($('#product-slide').length){
		$('#product-slide').owlCarousel({
			autoplay:true,
			dots: false,
			nav: true,
			navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
			rewind:true,
			autoplayTimeout:5000,
			loop:true,
			items:4,
			margin:30,
			responsive:{
				200:{ items:1 },
				300:{ items:1 },
				480:{ items:2 },
				630:{ items:3 },
				980:{ items:3 },
				1260:{ items:4 }
			}
		});
	}

	if($('#review-slide').length){
		$('#review-slide').owlCarousel({
			autoplay:true,
			dots: false,
			nav: true,
			navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
			rewind:true,
			autoplayTimeout:5000,
			loop:true,
			items:1,
			margin:20,
			responsive:{
				200:{ items:1 },
				300:{ items:1 },
				630:{ items:1 },
				980:{ items:1 }
			}
		});
	}

    if($('#collectn').length){
          $('#collectn').owlCarousel({
              autoplay:true,
              dots: false,
              nav: true,
              navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
              rewind:true,
              autoplayTimeout:5000,
              loop:true,
              items:3,
              margin:20,
              responsive:{
                  200:{ items:1 },
                  300:{ items:1 },
                  630:{ items:2 },
                  980:{ items:3 }
              }
          });
      }
	$('.faq-head').click(function(){
        $(this).toggleClass('active');
        $(this).siblings().slideToggle();
    });

	
	////////////
	
	/*$.instagramFeed({
		'username': 'stanwellskids',
		'container': "#instafeed",
		'display_profile': false,
		'display_biography': false,
		'display_gallery': true,
		'callback': null,
		'styling': true,
		'items':6,
		'items_per_row':6,
		'margin':0 
	});*/
});


